// controllers/useCreateLobbyController.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPersistentUserId } from '@api/userService.js';
import socket from '@api/socket.js';
import { logDev } from '@utils/logDev.js';

export function useLobbyCreateController() {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [isPrivate, setIsPrivate] = useState(false);
    const persistentId = getPersistentUserId();
    const navigate = useNavigate();

    const handleCreateLobby = () => {
        if (userName.trim() === '') {
            alert('Bitte gib deinen Namen ein.');
            return;
        }

        const options = isPrivate && password ? { password } : {};

        socket.emit(
            'createLobby',
            {
                user: { persistentId, name: userName },
                options
            },
            (lobby) => {
                logDev('Lobby erstellt:', lobby);
                navigate(`/lobby/${lobby.code}`);
            }
        );
    };

    return {
        userName,
        setUserName,
        password,
        setPassword,
        isPrivate,
        setIsPrivate,
        handleCreateLobby,
        navigate
    };
}